import { render } from "./mShopCase.vue?vue&type=template&id=6371b4d3&scoped=true"
import script from "./mShopCase.vue?vue&type=script&lang=js"
export * from "./mShopCase.vue?vue&type=script&lang=js"

import "./mShopCase.vue?vue&type=style&index=0&id=6371b4d3&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6371b4d3"]])

export default __exports__